import React, { useCallback, useEffect, useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';

import {
  MaintenanceHeader,
  selectTabEnum
} from '../components/organisms/Maintenance/MaintenanceHeader';
import { MaintenanceOtherTitle } from '../components/organisms/Maintenance/MaintenanceOtherTitle';
import SignageSearchBox from '../components/organisms/Maintenance/SearchWindow/SignageSearchBox';
import {
  SignagesType,
  MaintenanceSignageTable
} from '../components/organisms/Maintenance/Table/MaintenanceSignageTable';
import { GetSignagesApi } from '../apis/GetMaintenance.api';

export interface SignageSearchCondition {
  sort: { key: string; sortType: boolean };
  course: string;
  inbound: string;
}

export const SignageMaintenance: React.FC = () => {
  const [query, setQuery] = useState<SignageSearchCondition>({
    sort: { key: '', sortType: false },
    course: '',
    inbound: ''
  });

  const [searchSwitch, setSearchSwitch] = useState(false);

  const SearchStateSwitch = useCallback(() => {
    setSearchSwitch(!searchSwitch);
  }, [searchSwitch]);

  const [maintenanceDatas, setMaintenanceDatas] = useState<
    SignagesType[] | undefined | null
  >();

  const GetApi = async () => {
    const response = await GetSignagesApi();
    if (response.success) {
      setMaintenanceDatas(response.data);
    }
  };

  useEffect(() => {
    GetApi();
  }, []);

  return (
    <>
      <Flex direction='column' h='100vh'>
        <MaintenanceHeader selectTab={selectTabEnum.Signages} />
        <MaintenanceOtherTitle selectTab={selectTabEnum.Signages} />
        <Box
          position='relative'
          display='grid'
          gridTemplateRows='0.1fr 2fr 0.1fr'
          gridTemplateColumns='3fr 1fr'
          h='100%'
        >
          <MaintenanceSignageTable
            SignageDatas={maintenanceDatas}
            setMaintenanceDatas={setMaintenanceDatas}
            Query={query}
            setQuery={setQuery}
            searchSwitch={searchSwitch}
          />

          <SignageSearchBox
            setMaintenanceDatas={setMaintenanceDatas}
            Query={query}
            setQuery={setQuery}
            SearchStateSwitch={SearchStateSwitch}
          />
        </Box>
      </Flex>
    </>
  );
};
